"use client";
import { useEffect, useState } from "react";
import Tabs from "../shared/Tabs/Tabs";

const InnerMasterPlanInfo = ({
	activeTab,
	setActiveTab,
	unitsFound,
	facilitiesFound,
	sectionTitle,
	sectionDescription,
	insideAmenitiesDetailsPage
}: {
	activeTab: string | number;
	setActiveTab: React.Dispatch<React.SetStateAction<string | number>>;
	unitsFound: boolean;
	facilitiesFound: boolean;
	sectionTitle?: string
	sectionDescription?: string
	insideAmenitiesDetailsPage?: boolean
}) => {
	const [options, setOptions] = useState<any>([]);

	useEffect(() => {
		if (unitsFound && facilitiesFound) {
			setOptions([
				{ title: "Units", value: "units" },
				{ title: "Facilities", value: "facilities" },
			]);
		} else if (unitsFound) {
			setOptions([{ title: "Units", value: "units" }]);
		} else if (facilitiesFound) {
			setOptions([{ title: "Facilities", value: "facilities" }]);
			setActiveTab("facilities");
		}
	}, [unitsFound, facilitiesFound]);

	return (
		<div className="inner_masterplan_info text-center flex flex-col items-center">
			{
				!insideAmenitiesDetailsPage && (
					<h2 className="text-h4 text-oWhite-100 pb-3 leading-[100%] capitalize">
						{sectionTitle ? sectionTitle : "Masterplan"}
					</h2>
				)
			}

			{
				insideAmenitiesDetailsPage ? (
					<p className="text-bodyM font-national text-oWhite-60 leading-[120%]">
						{sectionDescription && sectionDescription}
					</p>
				) : (
					<p className="text-bodyM font-national text-oWhite-60 leading-[120%]">
						{sectionDescription ? sectionDescription : "Live in the warm, cosmopolitan scene of O West, where the core elements of beauty are all yours, where your core needs that define comfort are all around."}
					</p>
				)
			}

			{
				!insideAmenitiesDetailsPage &&
				<Tabs
					activeTab={activeTab}
					setActiveTab={setActiveTab}
					data={options}
					customClass="py-0"
				/>
			}

		</div>
	);
};

export default InnerMasterPlanInfo;
